t = require('views/internal/teacup-with-helpers')('card_detail')

module.exports = t.renderable (selector, icon, text, isCustom) ->
  t.a ".button-link.#{selector}", {
    href: '#',
    title: t.l(text)
  }, ->
    t.icon icon, { class: t.classify('icon-custom': isCustom) }
    t.span -> t.format text



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_sidebar_button.coffee